export const DEFAULT_EMPTY_VALUE = '-';
export const DEFAULT_DRAWER_WIDTH = 600;
